import React from 'react';
import { Button } from './ui/button';
import { Target, TrendingUp, Shield, Puzzle, ArrowRight } from 'lucide-react';
import { features, companyInfo } from '../data/mock';

const iconMap = {
  Target: Target,
  TrendingUp: TrendingUp,
  Shield: Shield,
  Puzzle: Puzzle
};

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-slate-50 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#e2e8f030_1px,transparent_1px),linear-gradient(to_bottom,#e2e8f030_1px,transparent_1px)] bg-[size:4rem_4rem]" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">About Us</span>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mt-3 mb-6 leading-tight">
              Technology Partner for
              <span className="text-teal-600"> Growing</span> Businesses
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              Spearca is a technology company delivering IT services and software solutions that help businesses operate efficiently, scale with confidence, and adapt to evolving market demands.
            </p>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              We focus on building robust digital systems and software products that address real operational and strategic challenges. Our approach starts with understanding business objectives, then delivering solutions that are practical, reliable, and designed for long-term use.
            </p>
            
            {/* Mission Statement */}
            <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm mb-8">
              <p className="text-slate-700 font-medium text-lg italic">
                "{companyInfo.mission}"
              </p>
            </div>

            <Button 
              className="bg-slate-900 hover:bg-slate-800 text-white px-6 py-3 rounded-lg transition-all duration-300 hover:shadow-lg group"
            >
              Learn More About Us
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          {/* Right - Features Grid */}
          <div className="grid grid-cols-2 gap-5">
            {features.map((feature, index) => {
              const IconComponent = iconMap[feature.icon];
              return (
                <div 
                  key={feature.id}
                  className={`bg-white rounded-2xl p-6 border border-slate-200 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group ${
                    index === 0 ? 'col-span-2 sm:col-span-1' : ''
                  }`}
                >
                  <div className="w-12 h-12 rounded-xl bg-slate-100 group-hover:bg-teal-100 flex items-center justify-center mb-4 transition-colors duration-300">
                    <IconComponent className="w-6 h-6 text-slate-600 group-hover:text-teal-600 transition-colors duration-300" />
                  </div>
                  <h3 className="text-lg font-semibold text-slate-900 mb-2">{feature.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
